<template>
    <div class="center">{{type}}</div>
</template>

<script>
import { setNavigationBarStyle } from '@/common/js/bridge'

export default {
  created(){
    const {type, immersion, noImmersion} = this.params
    this.type = type && this.getObj(type)
    this.immersion = immersion && this.getObj(immersion)
    this.noImmersion = noImmersion && this.getObj(noImmersion)
    if(immersion) {
      setNavigationBarStyle(this.immersion)
    } else {
    // 注册点击分享之后的回调事件。供端上触发
    Soda.customer && (Soda.customer.triggerShareButtonEvent = () => {
      // 跳转到历史页面
      this.rightClick()
    })
    this.updateNav(this.noImmersion)
    }
  },
  data() {
    return {
      immersion:{},
      noImmersion:{},
      type: '111'
    }
  },
  methods:{
    rightClick () {
     alert('触发了点击事件')
    },
    updateNav (noImmersion) {
      this.SodaBridge('updateNav', noImmersion)
    },
    getObj(info){
      return JSON.parse(decodeURIComponent(info))
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>